import React from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { formatUtilizationPercent } from 'bringg-web/features/delivery-blocks-v2/utils/delivery-block-utilization';

import styles from './delivery-block-utilization-metrics.module.scss';

interface Props {
	resourcesCount: number;
	maxResources: number;
	ordersCount: number;
	utilizationPercent?: number | null;
	testIdPrefix: string;
}

const EMPTY_VALUE = '-';

const DeliveryBlockUtilizationMetrics: React.FC<Props> = ({
	resourcesCount,
	maxResources,
	ordersCount,
	utilizationPercent,
	testIdPrefix
}) => {
	return (
		<span className={styles.metrics}>
			<span className={styles.metric} data-test-id={`${testIdPrefix}-resources`}>
				<BringgIcon iconName={BringgFontIcons.Resources} />
				{`${resourcesCount}/${maxResources}`}
			</span>
			<span className={styles.divider} />
			<span className={styles.metric} data-test-id={`${testIdPrefix}-orders`}>
				<BringgIcon iconName={BringgFontIcons.Orders} />
				{ordersCount}
			</span>
			<span className={styles.divider} />
			<span className={styles.metric} data-test-id={`${testIdPrefix}-utilization`}>
				{utilizationPercent == null ? EMPTY_VALUE : formatUtilizationPercent(utilizationPercent)}
			</span>
		</span>
	);
};

export default DeliveryBlockUtilizationMetrics;
